import { KIVUNOVA_WEBSITE_PATHS } from "../constants/kivunovaWebsite";

/**
 * Base URL for the Kivunova marketing/legal website.
 * Set REACT_APP_KIVUNOVA_WEBSITE_URL in .env.local (e.g. https://www.kivunova.com).
 */
const KIVUNOVA_WEBSITE_BASE_URL = process.env.REACT_APP_KIVUNOVA_WEBSITE_URL;

/** Full URL for a Kivunova website page. Returns "#" when REACT_APP_KIVUNOVA_WEBSITE_URL is not set. */
export const getKivunovaWebsiteUrl = (path: string, lang?: string): string => {
  if (!KIVUNOVA_WEBSITE_BASE_URL) {
    return "#";
  }

  const base = `${KIVUNOVA_WEBSITE_BASE_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;

  if (!lang) {
    return base;
  }

  return `${base}?${new URLSearchParams({ lang: lang || "en" }).toString()}`;
};

export const getWhoWeAreUrl = (lang: string): string =>
  getKivunovaWebsiteUrl(KIVUNOVA_WEBSITE_PATHS.whoWeAre, lang);

export const getOurServicesUrl = (lang: string): string =>
  getKivunovaWebsiteUrl(KIVUNOVA_WEBSITE_PATHS.ourServices, lang);

export const getOurTeamUrl = (lang: string): string =>
  getKivunovaWebsiteUrl(KIVUNOVA_WEBSITE_PATHS.ourTeam, lang);

export const getTermsUrl = (lang: string): string =>
  getKivunovaWebsiteUrl(KIVUNOVA_WEBSITE_PATHS.terms, lang);

/** Full URL for the privacy policy page (append ?lang= for locale). */
export const getPrivacyPolicyUrl = (lang: string): string =>
  getKivunovaWebsiteUrl(KIVUNOVA_WEBSITE_PATHS.privacy, lang);
